module.exports = __webpack_public_path__ + "img/weather-windy.8b797d36.svg";